<template>
  <div class="project" >

    
    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
          <img id="navbar-logo" src="../../assets/projects/hex/hex.jpg" alt="Solid Logo">
      </div>
    </nav>

    <h1>HEX (2018) in Eindhoven</h1>
    <br>
    <video src="../../assets/projects/hex/MlhHEX2018KittenRun.mp4" controls autoplay></video>
    <br>
      <p>
        Our experience in the HEX 2018 Hackathon held in Eindhoven, The Netherlands, on March 2018. Our submission was the result of 32 fun hours of nonstop coding (and occasionally sleeping on inflatable flamingoes).
      </p> <br>
      <p>
        Our entry was participating on the VR/AR category. The deliverable was a running game (Temple Run style) in which the player has to avoid several obstacles. However the concept we wanted to prove with it has a little bit more depth to it:
      </p><br>
      <p>
        Virtual Reality is nowadays still not within reach of everyone. With new VR devices coming out all the time, it's hard to keep up with buying all these expensive gadgets. Particularly, one must buy handheld controllers in order to interact with the virtual environment.
      </p><br>
      <p>
        What we achieved was to prove that it's possible to repurpose any kind of smart or connected device in order to use it as a controller. We built a software library for Unity which allows the developer to access a local server (a Raspberry Pi in our case) running an MQTT broker. To this server it is possible to connect all kinds of devices, as long as they can communicate with MQTT or HTTP requests. For our demo, we successfully connected things like a presentation pointer, a wireless keyboard, and even custom hardware on a harness we built with a Nordic NRF51development board that communicates via BLE. Using this harness, the user could physically jump, sidestep, crouch, plank, etc, in order to avoid the obstacles coming to him/her in the virtual world. For the headset, we used a Google cardboard (an 8 euro alternative) attached to a smartphone.
      </p><br>
      <p>
        This video is just for fun. It shows the game (and its really broken physics) at a very early stage of development during the Hackathon.
      </p><br>
      <p>
        The final outcome was successfully interfacing these devices to our game. The possibilities are endless. One can connect any IoT devices (switches, door sensors, toothbrushes) or literally any other smart electronics, in order to interact with the Virtual environment.
      </p><br>
      <p>
        Our entry won the first prize at the competition! And better yet, part of the prize was a Golden Ticket to participate in the Junction Hackathon which will be held in Finland by the end of the year. We can't wait to see what we build there!
      </p><br>
      <p>
        Thanks to all the HEX crew for making this experience incredible and unforgettable. We'll definitely be back next year!
      </p>

      <ul>
        <h2>  The Kitten Run team: </h2>
        <li>  Laura Donadoni (Italy)</li>
        <li>  Sergio Soto (Mexico)</li>
        <li>  Philipp Durnay (Germany)</li>
        <li>  Nikolas Skartsilas (Greece)</li>
        <li>  Davey Hurkmans (Netherlands)</li>
      </ul>


      <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/4.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/5.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/6.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/1.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/2.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/3.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/7.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/8.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/9.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/10.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/11.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/12.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/13.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/14.jpg" alt="hex">
        </div>
        <div class="column is-one-third is-vcentered">
            <img src="../../assets/projects/hex/16.jpg" alt="hex">
        </div>
      </div> 
    <br>


    </div>
</template>

<style scoped>
  
@import 'project.css';

</style>